export default {
  Monday: 'Thứ 2',
  Tuesday: 'Thứ 3',
  Wednesday: 'Thứ 4',
  Thursday: 'Thứ 5',
  Friday: 'Thứ 6',
  Saturday: 'Thứ 7',
  Sunday: 'Chủ nhật',

  'By Day': 'Theo ngày',
  'By Week': 'Theo tuần',
  'By Month': 'Theo tháng',
  'By Year': 'Theo năm',

  // Filter Date
  Today: 'Hôm nay',
  days: 'ngày',
  'Last x days': '{{numbers}} ngày gần nhất',
  'Last 30 days': '30 ngày gần nhất',
  'This month': 'Tháng này',
  'This Month': 'Tháng này',
  'This quarter': 'Quý này',
  'All time': 'Tất cả',
  Custom: 'Tùy biến',
};
